module.exports = __webpack_public_path__ + "img/Perak.bc66dd8e.png";